// extracted by mini-css-extract-plugin
export default {"layout":"QuickDepositPopup__layout--EYQ","popup":"QuickDepositPopup__popup--2Wb"};